// Add your custom JS here.
// Note: Navbar height is now handled by js/sticky-nav.js which is enqueued separately.

function initLorensbergsInteractions() {
	document.querySelectorAll('.course-btn-book[data-amelia-widget]').forEach(button => {
		const dialog = document.getElementById(button.dataset.courseBookingDialog);
		const widget = document.getElementById(button.dataset.ameliaWidget);
		const widgetRoot = widget ? widget.querySelector('.amelia-v2-booking') : null;
		let loadIntervalId;
		let loadTimeoutId;
		let hasRequestedLoad = false;

		if (!dialog || !widgetRoot) {
			return;
		}

		const hasLoadedWidget = () => Array.from(widgetRoot.classList).some(className => (
			/^amelia-v2-booking-\d+-loaded$/.test(className)
		));

		const clearLoadingTimers = () => {
			window.clearInterval(loadIntervalId);
			window.clearTimeout(loadTimeoutId);
			loadIntervalId = undefined;
			loadTimeoutId = undefined;
		};

		const updateLoadingState = () => {
			const hasLoaded = hasLoadedWidget();

			dialog.classList.toggle('is-loaded', hasLoaded);

			if (hasLoaded) {
				clearLoadingTimers();
				button.removeAttribute('aria-busy');
			}
		};

		const requestWidgetLoad = () => {
			if (hasLoadedWidget() || hasRequestedLoad) {
				return;
			}

			button.setAttribute('aria-busy', 'true');

			const loadWidget = () => {
				const shortcodeData = Array.isArray(window.ameliaShortcodeDataTriggered)
					? window.ameliaShortcodeDataTriggered.find(data => data.trigger === button.id)
					: null;

				if (!shortcodeData || typeof window.amelia?.load !== 'function') {
					return;
				}

				hasRequestedLoad = true;
				window.clearInterval(loadIntervalId);
				loadIntervalId = undefined;
				window.amelia.load(shortcodeData);
			};

			loadWidget();

			if (!hasRequestedLoad) {
				loadIntervalId = window.setInterval(loadWidget, 250);
			}

			loadTimeoutId = window.setTimeout(() => {
				clearLoadingTimers();
				hasRequestedLoad = false;
				button.removeAttribute('aria-busy');
			}, 12000);
		};

		const observer = new MutationObserver(updateLoadingState);
		observer.observe(widgetRoot, { attributes: true });
		updateLoadingState();

		const closeDialog = () => {
			if (typeof dialog.close === 'function') {
				dialog.close();
			} else {
				dialog.removeAttribute('open');
			}
		};

		const closeDialogForAmeliaPopup = () => {
			const hasVisiblePopup = Array.from(document.querySelectorAll('.am-dialog-popup')).some(popup => {
				const styles = window.getComputedStyle(popup);
				return styles.display !== 'none' && styles.visibility !== 'hidden';
			});

			if (dialog.open && hasVisiblePopup) {
				closeDialog();
			}
		};

		button.addEventListener('click', function() {
			if (!dialog.open) {
				if (typeof dialog.showModal === 'function') {
					dialog.showModal();
				} else {
					dialog.setAttribute('open', '');
				}
			}

			requestWidgetLoad();
		});

		dialog.querySelectorAll('[data-course-dialog-close]').forEach(closeButton => {
			closeButton.addEventListener('click', closeDialog);
		});

		dialog.addEventListener('click', event => {
			if (event.target === dialog) {
				closeDialog();
				return;
			}

			if (widget.contains(event.target)) {
				window.setTimeout(closeDialogForAmeliaPopup, 0);
				window.setTimeout(closeDialogForAmeliaPopup, 250);
			}
		}, true);
	});

	document.querySelectorAll('.people-about p, .people-big-box-content > *').forEach(element => {
		const text = element.textContent.replace(/[\s\u00a0\u200b\ufeff]/g, '');

		if (!text) {
			element.remove();
		}
	});

	document.querySelectorAll('.people-big-box').forEach(box => {
		const text = box.textContent.replace(/[\s\u00a0\u200b\ufeff]/g, '');

		if (!text) {
			box.remove();
		}
	});

	const ctaBlocks = document.querySelectorAll('.wp-block-cover.cta-image');

	ctaBlocks.forEach(block => {
		const link = block.querySelector('a');
		if (link) {
			block.addEventListener('click', function(e) {
				// Don't double-trigger if clicking on the link itself
				if (e.target !== link && !link.contains(e.target)) {
					link.click();
				}
			});
		}
	});

	const frankTileImage = document.querySelector('.wp-block-agoodblocks-media-grid-item img[src*="Frank_Mosaic_2"]');
	const frankTile = frankTileImage ? frankTileImage.closest('.wp-block-agoodblocks-media-grid-item:not(a)') : null;
	const frankUrl = 'https://lorensbergs.se/en/in-memory-of-frank-stenman/';

	if (frankTile) {
		frankTile.setAttribute('role', 'link');
		frankTile.setAttribute('tabindex', '0');
		frankTile.setAttribute('aria-label', 'In memory of Frank Stenman');
		frankTile.style.cursor = 'pointer';

		frankTile.addEventListener('click', function() {
			window.location.href = frankUrl;
		});

		frankTile.addEventListener('keydown', function(e) {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				window.location.href = frankUrl;
			}
		});
	}
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initLorensbergsInteractions);
} else {
	initLorensbergsInteractions();
}
